import {
  ResourcesDisplayField,
} from 'core-app/shared/components/fields/display/field-types/resources-display-field.module';
import { InjectField } from 'core-app/shared/helpers/angular/inject-field.decorator';
import { AttachmentsApiV3Service } from '../services/attachments-api-v3.service';

export class AttachmentLinksDisplayField extends ResourcesDisplayField {
  @InjectField() attachmentsApiV3Service:AttachmentsApiV3Service;

  public get valueString():string {
    return this.stringValue.join(", ");
  }

  public render(element:HTMLElement, displayText:string):void {
    const values = this.resource['attachmentLinks'];
    element.innerHTML = '';
    if (!values || values.length === 0) {
      this.renderEmpty(element);
    } else {
      this.renderValues(values, element);
    }
  }

  public get stringValue():string[] {
    const cf = this.resource['attachmentLinks'];

    if (this.schema && cf) {
      if (cf.elements) {
        return cf.elements.map((e:any) => e.$link.title);
      }
      if (cf.map) {
        return cf.map((e:any) => e.$link.title);
      }
      if (cf.name) {
        return [cf.name];
      }
      return [`error: ${JSON.stringify(cf)}`];
    }

    return [];
  }

  protected renderValues(values:any, element:HTMLElement) {
    values.forEach((value:any, idx:number) => {
      const link = document.createElement('a');
      link.textContent = value.name;
      link.setAttribute('target', '_blank')
      element.appendChild(link);
      if (idx !== values.length - 1) {
        element.appendChild(document.createTextNode(', '))
      }
      this
        .attachmentsApiV3Service
        .attachments
        .id(value.id)
        .get()
        .subscribe((attachment:any) => {
          link.setAttribute('href', attachment.$links.staticDownloadLocation.href);
        });
    });
  }
}
